import { render } from "./advisorAdviceOverview.vue?vue&type=template&id=72ce2f6d&scoped=true&ts=true"
import script from "./advisorAdviceOverview.vue?vue&type=script&lang=ts"
export * from "./advisorAdviceOverview.vue?vue&type=script&lang=ts"

import "./advisorAdviceOverview.vue?vue&type=style&index=0&id=72ce2f6d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ce2f6d"]])

export default __exports__